export class Video {
    VideoID: number = -1;
    Title: string = '';
    Description: string = '';
    Duration: number = 0;
    CategoryVideoID: number | null = null;  // Cambiado a null
    ThumbnailURL: string = '';
    SortOrder: number = 1;
    URL: string = '';
    CreatedBy: string = '';
    Active: boolean = true;
    CategoryName: string = '';
}
